import styled, { css } from 'styled-components';

import Tooltip from '../../../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
	isEmpt: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #b0bec5;
  padding: 10px 0;
  width: 100%;
  color: #455a64;
  cursor: pointer;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: var(--azul-razio);
      border-color: var(--azul-razio);
    `}

  ${props =>
    props.isField &&
    css`
      color: var(--azul-razio);
    `}

  select {
    flex: 1;
    background: transparent;
    border: 0;
    color: #000;
		font-weight: 500;
    cursor: pointer;

		${props =>
			props.isEmpt &&
			css`
				color: #90a4ae;
			`}

    :focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }

    &::placeholder {
      color: #90a4ae;
    }
  }

  > svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
